// Componente de input arredondado — campo de entrada reutilizável com estilo padrão
// Aceita estilos extras via prop "style" para personalização
function RoundedInput({ placeholder, value, onChange, type = "text", style: extraStyle }) {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        width: "100%",
        padding: "16px 28px",
        borderRadius: 40,
        border: "none",
        background: "#e8e8e8",
        fontSize: 16,
        fontFamily: "'DM Sans', sans-serif",
        color: "#666",
        outline: "none",
        boxSizing: "border-box",
        ...extraStyle,
      }}
    />
  );
}

export default RoundedInput;
